/**
 * CareNeedService
 * Service for managing the care need catalog
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for care need catalog CRUD operations
 */
export class CareNeedService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CareNeedService.DEFAULT_SERVICE_PATH,
            basePath: CareNeedService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CareNeedService.DEFAULT_SERVICE_PATH = 'ac-counselling';
CareNeedService.BASE_PATH = 'api/care-needs';
//# sourceMappingURL=CareNeedService.js.map